import React from "react";

export class Spinner extends React.PureComponent {
  public render() {
    return (
      <div className="lds-ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    );
  }
}
